import { Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/home';

export default function NewsSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新动态
            </h2>
            <p className="text-foreground-500 text-sm">水野朝阳的最新资讯与活动报道</p>
          </div>
          <Link
            to="/category/news"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            更多资讯
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {newsArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex gap-4 bg-background-50 border border-background-200/70 rounded-xl p-4 hover:border-accent-200/60 transition-all duration-300"
            >
              <div className="w-28 h-20 md:w-36 md:h-24 shrink-0 rounded-lg overflow-hidden">
                <div
                  className="w-full h-full bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                  style={{ backgroundImage: `url(${article.image})` }}
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <span className="inline-block px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded-full mb-1.5">
                    {article.category}
                  </span>
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 mt-1">{article.date}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}